import React, { useEffect, useMemo } from "react";
import { Grid, Card } from "@material-ui/core";
import { BodyWithPadding } from "../../styles/genericStyles.js";
import { NumberBox } from "devextreme-react/number-box";
import { useSelector } from "react-redux";
import colors from "../../styles/colors.js";
import { getUIData, setUIData } from "../../redux/slices/uiSlice.js";
import { useDispatch } from "react-redux";
import { numberWithCommas } from "../../utils/strings.js";
import { TextBox } from "devextreme-react";

const ItemInfo = ({ itemInfoFields }) => {
  const dispatch = useDispatch();
  const itemInfo = useSelector((state) => getUIData(state, "itemInfo"));

  const filteredItems = useSelector((state) =>
    getUIData(state, "filteredItems")
  );

  useEffect(() => {
    const overallValue = (filteredItems || []).reduce((acc, listItem) => {
      let price = listItem.quantity * listItem.price;
      if (itemInfoFields.includeCommission)
        price = price * (1 + listItem.commission / 100.0);
      return acc + parseFloat(price);
    }, 0);

    dispatch(
      setUIData({
        name: "itemInfo",
        value: { overallValue: overallValue },
      })
    );
  }, [filteredItems, dispatch, itemInfoFields.includeCommission]);

  const finalAmount = useMemo(() => {
    let finalAmount = itemInfo.overallValue * (1 - itemInfo.discount / 100);

    if (itemInfoFields.trans) {
      finalAmount = finalAmount + itemInfo.transport_cost;
    }
    if (itemInfoFields.packing) {
      finalAmount = finalAmount + itemInfo.packing_cost;
    }

    return numberWithCommas(finalAmount);
  }, [
    itemInfo.discount,
    itemInfo.overallValue,
    itemInfo.packing_cost,
    itemInfo.transport_cost,
    itemInfoFields.packing,
    itemInfoFields.trans,
  ]);

  return (
    <Card
      style={{
        backgroundColor: colors.blue,
      }}
    >
      <BodyWithPadding padding="3%">
        <Grid container justifyContent="center" spacing={1} alignItems="center">
          {itemInfoFields.price && (
            <>
              <Grid item xs={6}>
                <b>Overall value</b>
              </Grid>
              <Grid item xs={6}>
                <TextBox
                  value={numberWithCommas(itemInfo.overallValue)}
                  disabled={true}
                />
              </Grid>
            </>
          )}
          {itemInfoFields.discount && (
            <>
              <Grid item xs={6}>
                <b>Discount</b>
              </Grid>
              <Grid item xs={6}>
                <NumberBox
                  onValueChanged={(e) =>
                    dispatch(
                      setUIData({
                        name: "itemInfo",
                        value: { discount: e.value },
                      })
                    )
                  }
                  value={itemInfo.discount}
                  min={0}
                  step={0.5}
                  max={100}
                  showSpinButtons={true}
                />
              </Grid>
            </>
          )}
          {itemInfoFields.packing && (
            <>
              <Grid item xs={6}>
                <b>Packing(B:S)</b>
              </Grid>
              <Grid item xs={3}>
                <NumberBox
                  onValueChanged={(e) =>
                    dispatch(
                      setUIData({
                        name: "itemInfo",
                        value: { vrt_packing_cost: e.value },
                      })
                    )
                  }
                  min={0}
                  value={itemInfo.vrt_packing_cost}
                />
              </Grid>
              <Grid item xs={3}>
                <NumberBox
                  onValueChanged={(e) =>
                    dispatch(
                      setUIData({
                        name: "itemInfo",
                        value: { packing_cost: e.value },
                      })
                    )
                  }
                  min={0}
                  value={itemInfo.packing_cost}
                />
              </Grid>
            </>
          )}
          {itemInfoFields.trans && (
            <>
              <Grid item xs={6}>
                <b>TransCost(B:S)</b>
              </Grid>

              <Grid item xs={3}>
                <NumberBox
                  onValueChanged={(e) =>
                    dispatch(
                      setUIData({
                        name: "itemInfo",
                        value: { vrt_transport_cost: e.value },
                      })
                    )
                  }
                  min={0}
                  value={itemInfo.vrt_transport_cost}
                />
              </Grid>
              <Grid item xs={3}>
                <NumberBox
                  onValueChanged={(e) =>
                    dispatch(
                      setUIData({
                        name: "itemInfo",
                        value: { transport_cost: e.value },
                      })
                    )
                  }
                  min={0}
                  value={itemInfo.transport_cost}
                />
              </Grid>
            </>
          )}
          {itemInfoFields.finalAmount && (
            <>
              <Grid item xs={6}>
                <b>Final Amount</b>
              </Grid>
              <Grid item xs={6}>
                <TextBox disabled={true} value={finalAmount} />
              </Grid>
            </>
          )}
        </Grid>
      </BodyWithPadding>
    </Card>
  );
};
export default ItemInfo;
